import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  TemplateCategory,
  TemplateCategoryRequest,
} from '../models/template.model';

@Injectable({ providedIn: 'root' })
export class TemplateCategoryApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/template-categories`;

  list(): Observable<TemplateCategory[]> {
    return this.http.get<TemplateCategory[]>(this.base);
  }

  getById(id: string): Observable<TemplateCategory> {
    return this.http.get<TemplateCategory>(`${this.base}/${id}`);
  }

  create(req: TemplateCategoryRequest): Observable<TemplateCategory> {
    return this.http.post<TemplateCategory>(this.base, req);
  }

  update(id: string, req: TemplateCategoryRequest): Observable<TemplateCategory> {
    return this.http.put<TemplateCategory>(`${this.base}/${id}`, req);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
